import { CorrespondenceIssuedCategoryDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CorrespondenceIssuedCategoryService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getCorrespondenceIssuedCategory(): Observable<
    CorrespondenceIssuedCategoryDto[]
  > {
    return this.http.get<CorrespondenceIssuedCategoryDto[]>(
      this.url + 'correspondence-issue-category'
    );
  }

  createCorrespondenceIssuedCategory(
    data: CorrespondenceIssuedCategoryDto[]
  ): Observable<CorrespondenceIssuedCategoryDto[]> {
    return this.http.post<CorrespondenceIssuedCategoryDto[]>(
      this.url + 'correspondence-issue-category',
      data
    );
  }
  getSingleCorrespondenceIssuedCategory(id: string): Observable<any> {
    return this.http.get(this.url + 'correspondence-issue-category/' + id);
  }

  updateCorrespondenceIssuedCategory(
    data: CorrespondenceIssuedCategoryDto[]
  ): Observable<CorrespondenceIssuedCategoryDto[]> {
    return this.http.post<CorrespondenceIssuedCategoryDto[]>(
      this.url + 'correspondence-issue-category/update',
      data
    );
  }

  deleteCorrespondenceIssuedCategory(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('correspondence-issue-category', ids.join(', '));
    return this.http.delete(
      this.url + 'correspondence-issue-category',
      httpOptions
    );
  }
}
